import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import { motion } from "framer-motion";
import SEO from "@/components/SEO";

const sections = [
  {
    title: "Main",
    links: [
      { label: "Home", path: "/" },
      { label: "Our Story", path: "/our-story" },
      { label: "Team", path: "/team" },
      { label: "Services", path: "/services" },
      { label: "Diversity", path: "/diversity" },
    ],
  },
    {
    title: "Resources",
    links: [
      { label: "News & Insights", path: "/news" },
      { label: "Archived Articles", path: "/archived-articles" },
      { label: "Join Us", path: "/join-us" },
      { label: "Locations", path: "/locations" },
      { label: "Client Intake", path: "/intake" },
      { label: "Newsletter Sign Up", path: "/newsletter" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Privacy Policy", path: "/privacy" },
      { label: "Disclaimer", path: "/disclaimer" },
    ],
  },
];

const SiteMapPage = () => {
  return (
    <Layout>
      <SEO title="Site Map | Vaughan McLean" description="Navigate all pages on the Vaughan McLean website including attorney bios, practice areas, office locations, and more." />
      <section className="pt-40 pb-24">
        <div className="container mx-auto px-8 lg:px-16">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="font-heading text-4xl md:text-5xl font-light tracking-wide text-foreground mb-16"
          >
            Site Map
          </motion.h1>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            {sections.map((section, i) => (
              <motion.div
                key={section.title}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
              >
                <h2 className="text-xs tracking-[0.2em] uppercase font-body font-semibold text-foreground mb-4">
                  {section.title}
                </h2>
                <ul className="space-y-3">
                  {section.links.map((link) => (
                    <li key={link.path}>
                      <Link
                        to={link.path}
                        className="text-muted-foreground text-sm hover:text-primary transition-colors font-body"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default SiteMapPage;
